import { Component, input, linkedSignal, output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { MatSlider, MatSliderThumb } from '@angular/material/slider';

@Component({
  imports: [MatSliderThumb, MatSlider, MatFormField, FormsModule, MatInput],
  selector: 'avs-slider',
  styleUrl: './slider.component.scss',
  templateUrl: './slider.component.html',
})
export class SliderComponent {
  valueChanged = output<number>();
  value = input(10);
  disabled = input(false);
  min = input(5);
  max = input(30);
  step = input(1);
  protected sliderValue = linkedSignal(() => this.value());

  protected sliderChange(value: number) {
    this.sliderValue.set(value);
    this.emitValue();
  }

  protected inputBlur() {
    if (this.sliderValue() > this.max()) {
      this.sliderValue.set(this.max());
    }
    if (this.sliderValue() < this.min()) {
      this.sliderValue.set(this.min());
    }
    this.emitValue();
  }

  private emitValue() {
    this.valueChanged.emit(this.sliderValue());
  }
}
